// The DIAGNOSIS: marker — frontend half.
//
// The troubleshooting AI signals a terminal turn by starting its reply with
// the literal token `DIAGNOSIS:`. The worker has its own copy of this contract
// in worker/lib/diagnosis.js. If the marker format changes, both files change
// together.
//
// ⚠️ The reason for the duplication is NOT that the bundles cannot share an
// import — this file used to say so and it is false. shared/turnMarkers.js is
// imported by both halves and measured inlined into each: vite emits it into
// dist/assets, and `wrangler deploy --dry-run` emits it into the worker
// bundle. This pair simply predates that module and has since drifted (the
// worker half grew normalizeDiagnosis, this half grew stripDiagnosisLabel);
// only DIAGNOSIS_MARKER is genuinely duplicated. Fold it into shared/ when
// something else forces the two to move together.

// Anchored to the START of the reply (no `m` flag) — kept in lockstep with
// worker/lib/diagnosis.js; see the rationale there.
const DIAGNOSIS_MARKER = /^\s*DIAGNOSIS\s*:/i;
const DIAGNOSIS_LABEL = /^\s*DIAGNOSIS\s*:\s*/i;

/** True when an AI turn's text is a final diagnosis rather than a question. */
export function isDiagnosis(text) {
  return DIAGNOSIS_MARKER.test(text || '');
}

/** Drop the leading "DIAGNOSIS:" label — the UI shows its own heading. */
export function stripDiagnosisLabel(text) {
  return (text || '').replace(DIAGNOSIS_LABEL, '');
}
